import React, { useState } from 'react';
import { Button } from './ui/button';
import { ChevronDown } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import QuoteModal from './QuoteModal';

const HeroSection = () => {
  const { translate } = useLanguage();
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - New Mercedes S-Class */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url('https://images.unsplash.com/photo-1609521233053-345bfa8b6f17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxNZXJjZWRlcyUyMFMtQ2xhc3N8ZW58MHx8fHwxNzU0OTk2OTQ0fDA&ixlib=rb-4.1.0&q=85')`
        }}
      />
      
      {/* Elegant overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />
      
      {/* Content */}
      <div className="relative z-10 text-center text-white px-6 max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-5xl md:text-7xl font-bold mb-4 leading-tight">
            LUXOR LIMOUSINE SA
            <span className="block text-yellow-400 text-4xl md:text-5xl mt-2">
              {translate('heroSubtitle')}
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/90 font-light">
            {translate('heroDescription')}
          </p>
        </div>
        
        <div className="mb-8">
          <p className="text-lg md:text-xl text-white/80 mb-6 max-w-2xl mx-auto">
            <span className="font-semibold text-yellow-400">{translate('heroTagline')}</span>
            <br />
            {translate('heroText')}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6">
          <Button 
            size="lg" 
            className="bg-yellow-500 hover:bg-yellow-600 text-black font-semibold px-8 py-3 text-lg rounded-full transform hover:scale-105 transition-all"
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
          >
            {translate('bookNow').toUpperCase()}
          </Button>
          <Button 
            variant="outline" 
            size="lg" 
            className="border-white/50 text-white hover:bg-white hover:text-black px-8 py-3 text-lg rounded-full transform hover:scale-105 transition-all"
            onClick={() => setIsQuoteModalOpen(true)}
          >
            {translate('requestQuote').toUpperCase()}
          </Button>
        </div>
        
        <div className="mt-16">
          <div className="animate-bounce">
            <ChevronDown size={32} className="mx-auto text-yellow-400" />
          </div>
        </div>
      </div>

      {/* Quote Modal */}
      <QuoteModal 
        isOpen={isQuoteModalOpen} 
        onClose={() => setIsQuoteModalOpen(false)} 
      />
    </section>
  );
};

export default HeroSection;